import React, { useRef, useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import AppNavbar from "./components/Navbar";
import Home from "./components/Home";
import Features from "./components/Features";
import About from "./components/About";
//import Contact from './components/Contact';
import Footer from "./components/Footer";
import Download from "./components/Download";
import WebAppPromo from "./components/WebAppPromo";
import "./App.scss";
import "./i18n";
import FAQ from "./components/FAQ";

const App = () => {
   const homeRef = useRef<HTMLDivElement>(null);
   const aboutRef = useRef<HTMLDivElement>(null);
   const servicesRef = useRef<HTMLDivElement>(null);
   const contactRef = useRef<HTMLDivElement>(null);
   const downloadRef = useRef<HTMLDivElement>(null);
   const faqRef = useRef<HTMLDivElement>(null);
   const deleteAccountRef = useRef<HTMLHeadingElement>(null);
   const dataRightsRef = useRef<HTMLHeadingElement>(null);

   const scrollToSection = (ref: React.RefObject<HTMLElement>) => {
      if (ref.current) {
         ref.current.scrollIntoView({ behavior: "smooth", block: "start" });
      }
   };

   useEffect(() => {
      const handleHashChange = () => {
         const fragment = window.location.hash.slice(1);
         switch (fragment) {
            case "download":
               scrollToSection(downloadRef);
               break;
            case "about":
               scrollToSection(aboutRef);
               break;
            case "faq":
               scrollToSection(faqRef);
               break;
            case "delete-account":
               if (deleteAccountRef.current) {
                  deleteAccountRef.current.scrollIntoView({
                     behavior: "smooth",
                  });
               }
               break;
            case "data-rights":
               if (dataRightsRef.current) {
                  dataRightsRef.current.scrollIntoView({ behavior: "smooth" });
               }
               break;
            default:
               break;
         }
      };

      window.addEventListener("hashchange", handleHashChange);

      handleHashChange();

      return () => {
         window.removeEventListener("hashchange", handleHashChange);
      };
   }, []);

   return (
      <div id='root'>
            <AppNavbar
               scrollToHome={() => scrollToSection(homeRef)}
               scrollToAbout={() => scrollToSection(aboutRef)}
               scrollToServices={() => scrollToSection(servicesRef)}
               scrollToContact={() => scrollToSection(contactRef)}
               scrollToDownload={() => scrollToSection(downloadRef)}
               scrollToFAQ={() => scrollToSection(faqRef)}
            />
            <div className='app-container'>
               <div ref={homeRef} id='home' className='section'>
                  <Home
                     scrollToServices={() => scrollToSection(servicesRef)}
                     scrollToContactUs={() => scrollToSection(contactRef)}
                  />
               </div>
               <div ref={downloadRef} id='download' className='section'>
                  <Download />
               </div>
               {/* Web app promo section under Download */}
               <div id='web-promo' className='section'>
                  <WebAppPromo />
               </div>
               <div ref={servicesRef} id='services' className='section'>
                  <Features />
               </div>
               <div ref={aboutRef} id='about' className='section'>
                  <About />
               </div>
               {/* <div ref={contactRef} id="contact" className="section">
            <Contact />
          </div> */}
               <div ref={faqRef} id='faq' className='section'>
                  <FAQ
                     deleteAccountRef={deleteAccountRef}
                     dataRightsRef={dataRightsRef}
                  />
               </div>
               <Footer />
            </div>
         </div>
   );
};

export default App;
